/* VOLTIGE — couche groupe : menu mobile, menus déroulants au clavier et au toucher,
   aperçu d'image de l'index, apparitions. Aucune dépendance. */
(function () {
  "use strict";
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduit = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Tiroir mobile ---------- */
  $$("[data-vt-burger]").forEach(btn => {
    const tiroir = document.getElementById(btn.getAttribute("aria-controls"));
    if (!tiroir) return;
    const fermer = () => { btn.setAttribute("aria-expanded", "false"); btn.setAttribute("aria-label", "Ouvrir le menu"); tiroir.hidden = true; document.documentElement.classList.remove("vt-menu-ouvert"); };
    btn.addEventListener("click", () => {
      const ouvrir = btn.getAttribute("aria-expanded") !== "true";
      if (!ouvrir) return fermer();
      btn.setAttribute("aria-expanded", "true"); btn.setAttribute("aria-label", "Fermer le menu");
      tiroir.hidden = false; document.documentElement.classList.add("vt-menu-ouvert");
      const premier = tiroir.querySelector("a"); premier && premier.focus({ preventScroll: true });
    });
    document.addEventListener("keydown", e => { if (e.key === "Escape" && btn.getAttribute("aria-expanded") === "true") { fermer(); btn.focus(); } });
    tiroir.addEventListener("click", e => { if (e.target.closest("a")) fermer(); });
    window.matchMedia("(min-width: 900px)").addEventListener("change", e => { if (e.matches) fermer(); });
  });

  /* ---------- « Gérer les cookies » : rouvre le bandeau de consentement de Shopify ;
     sans bandeau chargé, le lien mène à la politique de cookies ---------- */
  document.addEventListener("click", e => {
    const a = e.target.closest && e.target.closest('a[href$="#gerer-cookies"]');
    if (!a || !window.privacyBanner || typeof window.privacyBanner.showPreferences !== "function") return;
    e.preventDefault(); window.privacyBanner.showPreferences();
  });

  /* ---------- Lien d'une vidéo (?v=TK-012, donné par le Studio Voltige) : le code est rangé dans les
     attributs du panier Shopify, donc repris sur la commande (« video: TK-012 »), pour savoir quelle vidéo
     a vendu. Seulement avec l'accord « statistiques » du bandeau de Shopify ; aucun stockage propre au thème.
     Le dernier lien suivi l'emporte. ---------- */
  (function () {
    const params = new URLSearchParams(location.search);
    const brut = params.get("v");
    if (!brut || !/^(TK|IG|YT)-\d{1,5}$/i.test(brut)) return;
    const code = brut.toUpperCase();
    // l'adresse affichée perd ?v= : un lien recopié ou partagé ne compte pas comme un clic de la vidéo
    params.delete("v");
    const reste = params.toString();
    history.replaceState(history.state, "", location.pathname + (reste ? "?" + reste : "") + location.hash);
    let fait = false;
    const enregistrer = () => {
      if (fait) return; fait = true;
      const racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
      fetch(racine + "cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: { video: code, video_le: new Date().toISOString().slice(0, 10) } })
      }).catch(() => {});
    };
    const S = window.Shopify;
    // aperçu local (pas de Shopify) : on enregistre directement
    if (!S || typeof S.loadFeatures !== "function") return enregistrer();
    document.addEventListener("visitorConsentCollected", e => { if (e.detail && e.detail.analyticsAllowed) enregistrer(); });
    S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], err => {
      if (err || !S.customerPrivacy) return;
      if (S.customerPrivacy.analyticsProcessingAllowed()) enregistrer();
    });
  })();

  /* ---------- Menus déroulants : Échap referme ---------- */
  document.addEventListener("keydown", e => {
    if (e.key !== "Escape") return;
    const item = document.activeElement && document.activeElement.closest("[data-vt-item]");
    if (item) { const lien = item.querySelector(".vt-nav__link"); lien && lien.focus(); lien && lien.blur(); }
  });

  /* ---------- Index des maisons : aperçu qui suit la souris ---------- */
  const apercu = document.querySelector("[data-vt-preview-img]");
  if (apercu && window.matchMedia("(hover: hover) and (min-width: 900px)").matches) {
    let x = 0, y = 0, cx = 0, cy = 0, actif = false, raf = 0;
    const boucle = () => {
      cx += (x - cx) * (reduit ? 1 : .18); cy += (y - cy) * (reduit ? 1 : .18);
      apercu.style.transform = `translate3d(${cx + 28}px, ${cy - 155}px, 0)`;
      raf = actif || Math.abs(x - cx) > .5 ? requestAnimationFrame(boucle) : 0;
    };
    $$("[data-vt-preview]").forEach(row => {
      row.addEventListener("mouseenter", e => {
        if (apercu.getAttribute("src") !== row.dataset.vtPreview) apercu.src = row.dataset.vtPreview;
        if (!actif) { cx = x = e.clientX; cy = y = e.clientY; }
        actif = true; apercu.classList.add("is-on"); if (!raf) raf = requestAnimationFrame(boucle);
      });
      row.addEventListener("mousemove", e => { x = e.clientX; y = e.clientY; if (!raf) raf = requestAnimationFrame(boucle); });
      row.addEventListener("mouseleave", () => { actif = false; apercu.classList.remove("is-on"); });
    });
  }

  /* ---------- Fiches produit : le bouton fixe suit le bouton du formulaire (variante épuisée, ajout en cours) ---------- */
  (function () {
    const principal = document.querySelector("form[data-buy] [data-add]");
    if (!principal) return;
    /* pages des maisons (/collections/lueur…) : elles vendent aussi le produit, mais sans barre d'achat d'origine */
    if (!document.querySelector(".sticky-buy")) {
      const barre = document.createElement("div");
      barre.className = "sticky-buy";
      const prix = document.createElement("div");
      prix.className = "price"; prix.setAttribute("data-sticky-price", "");
      const source = principal.closest("form").parentElement.querySelector("[data-price]") || document.querySelector("[data-price]");
      prix.textContent = source ? source.textContent : "";
      const bouton = document.createElement("button");
      bouton.className = "btn btn--primary"; bouton.type = "button";
      bouton.addEventListener("click", () => principal.click());
      barre.append(prix, bouton);
      document.body.appendChild(barre);
    }
    const fixe = document.querySelector(".sticky-buy .btn");
    if (!fixe) return;
    const suivre = () => { fixe.disabled = principal.disabled; fixe.textContent = principal.textContent; };
    new MutationObserver(suivre).observe(principal, { attributes: true, attributeFilter: ["disabled"], childList: true, characterData: true, subtree: true });
    suivre();
  })();

  /* ---------- Apparitions ---------- */
  const cibles = $$(".vt-panel__txt, .vt-mcard, .vt-index__head, .vt-row, .vt-engage__list > li, .vt-feature").filter(el => !el.closest(".vt-hero"));
  cibles.forEach(el => el.classList.add("vt-rv"));
  if (reduit || !("IntersectionObserver" in window)) { cibles.forEach(el => el.classList.add("in")); return; }
  const io = new IntersectionObserver(es => es.forEach(x => {
    if (!x.isIntersecting) return;
    const el = x.target.closest("li") || x.target;
    const freres = el.parentElement ? Array.from(el.parentElement.children) : [];
    const rang = Math.max(0, freres.indexOf(el));
    x.target.style.transitionDelay = Math.min(rang, 6) * 60 + "ms";
    x.target.classList.add("in"); io.unobserve(x.target);
  }), { threshold: .12, rootMargin: "0px 0px -6% 0px" });
  cibles.forEach(el => io.observe(el));
})();
